import {useEffect,useState} from 'react';
import {useLocation} from 'react-router-dom';
import useTranslate from '../../hooks/useTranslate';
import {getPageSeo,applySeo,cleanPath} from '../../lib/seo';
export default function SiteSeo(){
  const {pathname}=useLocation();const {language}=useTranslate();const [article,setArticle]=useState(null);
  useEffect(()=>{setArticle(null);const listener=event=>{if(cleanPath(event.detail.path)===cleanPath(pathname))setArticle(event.detail.article);};window.addEventListener('kavak:article-seo',listener);return()=>window.removeEventListener('kavak:article-seo',listener);},[pathname]);
  useEffect(()=>{applySeo(getPageSeo(pathname,language||'en',article));},[pathname,language,article]);
  return null;
}
